import { Button, Typography } from 'mobily-ui-library';
import { useTranslation } from 'react-i18next';

import './ClaimCardButton.scss';

interface Props {
    rtl: boolean;
    amount: string;
    claimPromo?: any;
    commitmentPeriod: string;
    totalAmount?: any;
    claimButtonEnable?: any;
    eligibleBills?:any;
    handleClaim: (value: string) => void;
}

function ClaimCardButton({ rtl, handleClaim, amount, claimPromo, commitmentPeriod, totalAmount, claimButtonEnable, eligibleBills }: Props) {

    const { t } = useTranslation();

    return (
        <div className='ClaimCard__Button'>
            <div className='CCB__section'>
                <div className='CCB__commiments'>
                    <Typography rtl={rtl} className='CCB__Amount'>{`${t('SAR')} ${amount} (${t('vat_exclusive')})`}</Typography>
                    <Typography rtl={rtl} className='CCB__Months'>{commitmentPeriod} {t('Months_commitment')}</Typography>
                    {totalAmount && (
                        <Typography rtl={rtl} className='CCB__Months'>{`${t('SAR')} ${totalAmount} ${t('Total')}`}</Typography>
                    )}
                    {eligibleBills && (
                        <Typography rtl={rtl} className='CCB__EligibilityMessage'>
                            {t('eligible_after_bills', {
                                bills: eligibleBills
                            })}</Typography>
                    )}
                </div>
                <Button
                    rtl={rtl}
                    className='CCB__Btn'
                    onClick={() => handleClaim(claimPromo)}
                    variant={claimButtonEnable ? 'default' : 'disabled'}
                >
                    {t('Claim')}
                </Button>
            </div>
        </div>
    )
}

export default ClaimCardButton